import { useContext, useState } from 'react'
import Radio from '../../../../Components/Radio/Radio'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import ImageLayout from '../../Layouts/ImageLayout/ImageLayout'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import './PhonePlanView.css'

const PhonePlanView = () =>
{
    let context = useContext(ConfiguratorContext)

    let [state, setState] = useState(context.isPhonePlan)

    context.validatePhonePlan = () =>
    {
        context.isPhonePlan = state
        return true
    }

    return (
        <ImageLayout src='../assets/phone.png'>
            <div className="phone-plan-main">
                <div className="phone-plan-title">Vuoi cambiare o attivare un piano telefonico?</div>
                <div className="text-center phone-plan-subtitle">
                    Sei interessato all'opzione aggiuntiva che consente di disporre di una LINEA TELEFONICA a pacchetto (1.000 minuti/mese verso i fissi ed i cellulari italiani)?
                </div>
                <div className="phone-plan-choices">
                    <Radio title="SI" onChange={() => setState(true)} checked={state}></Radio>
                    <Radio title='NO' onChange={() => setState(false)} checked={!state}></Radio>
                </div>
            </div>
        </ImageLayout>
    )
}

const PhonePlanNode: NavigationNode = {
    content: () => <PhonePlanView />,
    percentage: 27,
    previous: (context: Configuration) => ViewType.homeUse,
    next: (context: Configuration) => context.isPhonePlan ? ViewType.currentNumber : ViewType.wifiCoverage
}

export default PhonePlanNode